<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Revenue"
              bc1="App"
              bc2="Revenue"
              bc3="Accounts"
          ></Breadcrumb>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section class="app-user-list">
          <section>
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">Accounts Details</h4>
                  </div>
                  <div>
                    <div class="row mt-2">
                      <div class="col-12">
                        <div class="card">
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                              <tr>
                                <th>Account Title</th>
                                <th>Balance</th>
                                <th>Balance On Hold</th>
                                <th>Available Balance</th>
                                <th>Currency</th>
                                <th>Actions</th>

                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(account,accountIndex) in accounts" :key="accountIndex">
                                <td><span class="badge badge-glow badge-info">{{ account.account_title }}</span></td>
                                <td><span
                                    class=" font-weight-bolder text-dark">{{ modifyAmount(parseFloat(account.balance / 100).toFixed(amountDecimalPlaces)) }}</span>
                                </td>
                                <td><span
                                    class=" font-weight-bolder text-dark">{{ modifyAmount(parseFloat(account.balance_on_hold / 100).toFixed(amountDecimalPlaces)) }}</span>
                                </td>
                                <td><span
                                    class=" font-weight-bolder text-dark">{{ modifyAmount(parseFloat(account.available_balance / 100).toFixed(amountDecimalPlaces)) }}</span>
                                </td>
                                <td><span class="badge badge-light-success">{{ account.currency.code }}</span></td>
                                <td>
                                  <button class="btn btn-sm btn-warning"
                                          @click="$router.push({name: 'revenue-summary',params: {id:account.currency_id,currency: account.currency.code}})">
                                    View Summary
                                  </button>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </section>
        <section class="app-user-list">
          <section>
            <div class="card">
              <h5 class="card-header">Search Filter</h5>
              <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
                <div class="col-lg-3 col-sm-12 ">
                  <date-picker
                      v-model="startDate"
                      valueType="format"
                      :disabledDate="disableFutureDates"
                      :lang="lang"
                      name="toDate"
                      placeholder="choose starting date"
                  ></date-picker>
                </div>
                <div class="col-lg-3 col-sm-12">
                  <date-picker
                      v-model="endDate"
                      :disabledDate="disableFutureDates"
                      valueType="format"
                      :lang="lang"
                      name="fromDate"
                      placeholder="choose ending date"
                  ></date-picker>
                </div>
                <div class="col-lg-3  col-sm-12">
                  <button type="button" class="btn btn-primary"  @click="onSubmitFilters" >Search</button>
                  <button type="button" class="ml-1 btn btn-danger " @click="clear" >Clear</button>
                </div>
              </div>


            </div>
            <div class="col-12 d-flex mt-3 mb-3  justify-content-center" v-if="filterLoader">
              <div class="spinner-border text-primary"></div>
            </div>
            <div class="row" v-show="!filterLoader">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">Currency Markup Revenue</h4>
                  </div>
                  <div>
                    <div class="col-12 d-flex mt-3 mb-3  justify-content-center" v-if="revenueLoader">
                      <div class="spinner-border text-primary"></div>
                    </div>
                    <div v-else class="row ">
                      <div class="col-12">
                        <div class="card-body">
                          <div class="row ">
                            <div class="col-md-12 col-12">
                              <div class="card ">
                                <div class="card-body">
                                  <div class="row  ">
                                    <div class="col-md-6 mt-2 col-sm-12  p-2" :class="exchangeRevenueTypes.length % 2 == 0?((exchangeRevenueIndex != exchangeRevenueTypes.length - 1 && exchangeRevenueIndex != exchangeRevenueTypes.length - 2)? 'border-bottom-dark':''):((exchangeRevenueIndex != exchangeRevenueTypes.length - 1)? 'border-bottom-dark':'') "
                                         v-for="(exchangeRevenue,exchangeRevenueIndex) in exchangeRevenueTypes"
                                         :key="exchangeRevenueIndex">
                                      <span style="cursor: pointer"><strong>{{
                                          exchangeRevenue.currency
                                        }}</strong></span>
                                      <br>
                                      <table>
                                        <tr>
                                          <td class="pr-1"><small class="text-warning font-weight-bolder">Markup Amount</small></td>
                                          <td>
                                            <span class=" font-weight-bolder">
                                            {{
                                                modifyAmount(parseFloat(exchangeRevenue.totalMarkupAmount / 100).toFixed(amountDecimalPlaces))
                                            }}</span>
                                          </td>
                                          <td class="pl-1">
                                            <span
                                                class="badge badge-light-success font-small-1">{{ exchangeRevenue.currency }}</span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="pr-1 "><span class="badge badge-light-danger font-small-1">Refunded</span></td>
                                          <td>
                                           <small class="text-danger font-small-1">({{ modifyAmount(parseFloat(exchangeRevenue.refundedTotalMarkupAmount / 100).toFixed(amountDecimalPlaces)) }})</small>
                                          </td>
                                          <td class="pl-1">
                                            <span
                                                class="badge badge-light-success font-small-1">{{ exchangeRevenue.currency }}</span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="pr-1">
                                            <small class="text-info font-weight-bolder">Total Amount</small>
                                          </td>
                                          <td>
                                            <span class=" font-weight-bolder">{{
                                                modifyAmount(parseFloat(exchangeRevenue.totalAmount / 100).toFixed(amountDecimalPlaces))
                                              }}</span>
                                          </td>
                                          <td class="pl-1">
                                            <span
                                                class="badge badge-light-success font-small-1">{{ exchangeRevenue.currency }}</span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="pr-1 "><span class="badge badge-light-danger font-small-1">Refunded</span></td>
                                          <td>
                                            <small class="text-danger font-small-1"
                                            >({{ modifyAmount(parseFloat(exchangeRevenue.refundedTotalAmount / 100).toFixed(amountDecimalPlaces)) }})</small>
                                          </td>
                                          <td class="pl-1">
                                            <span
                                                class="badge badge-light-success font-small-1">{{ exchangeRevenue.currency }}</span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td> <hr class="my-50 border-top-dark" style="width: 102% !important;"></td>
                                          <td> <hr class="my-50 border-top-dark" style="width: 104% !important;"></td>
                                          <td> <hr class="my-50 border-top-dark " ></td>
                                        </tr>
                                        <tr>
                                          <td class="pr-1">
                                            <small class=" text-primary font-weight-bolder">Revenue</small>
                                          </td>
                                          <td>
                                            <span class="font-weight-bolder font-medium-1">
                                            {{
                                                modifyAmount(parseFloat(((parseFloat(exchangeRevenue.totalMarkupAmount) - parseFloat(exchangeRevenue.refundedTotalMarkupAmount)) - (parseFloat(exchangeRevenue.totalAmount) - parseFloat(exchangeRevenue.refundedTotalAmount))) / 100).toFixed(amountDecimalPlaces))
                                            }}</span>
                                          </td>
                                          <td class="pl-1">
                                            <span
                                                class="badge badge-light-success font-small-1">{{ exchangeRevenue.currency }}</span>
                                          </td>
                                        </tr>

                                      </table>
                                      <!--                                      <span> <small class="text-warning">Markup Amount</small> {{ parseFloat(exchangeRevenue.totalMarkupAmount/100).toFixed(amountDecimalPlaces) }} <span class="text-danger font-medium-1 font-weight-bolder"  style="margin: 2%">- {{parseFloat(exchangeRevenue.refundedTotalMarkupAmount/100).toFixed(amountDecimalPlaces)}}</span>&nbsp;<span class="badge badge-light-success font-small-1">{{exchangeRevenue.currency}}</span></span>-->
                                      <!--                                      <br>-->
                                      <!--                                      <span> <small class="text-info">Total Amount</small> {{ parseFloat(exchangeRevenue.totalAmount/100).toFixed(amountDecimalPlaces) }} <span class="text-danger font-medium-1 font-weight-bolder"  style="margin: 2%">- {{parseFloat(exchangeRevenue.refundedTotalAmount/100).toFixed(amountDecimalPlaces)}}</span>&nbsp;<span class="badge badge-light-success">{{exchangeRevenue.currency}}</span></span>-->
                                      <!--                                      <br>-->
                                      <!--                                      <span> <small class="text-primary">Revenue</small> {{ parseFloat(((parseFloat(exchangeRevenue.totalMarkupAmount) - parseFloat(exchangeRevenue.refundedTotalMarkupAmount) )-(parseFloat(exchangeRevenue.totalAmount) - parseFloat(exchangeRevenue.refundedTotalAmount) ))/100).toFixed(amountDecimalPlaces) }} 	&nbsp;<span class="badge badge-light-success">{{exchangeRevenue.currency}}</span></span>-->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </section>


      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {DatePicker},
  mounted() {
    this.sendCall()
  },
  data() {
    return {
      filteredData:{},
      accounts: [],
      exchangeRevenueTypes: [],
      filterLoader:false,
      revenueLoader:false,
      startDate: "",
      endDate: "",
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
    }
  },
  methods: {
    onSubmitFilters() {
      this.filterLoader = true

      let filterData = {}

      if(this.startDate){
        filterData.startDate = this.startDate
      }
      if(this.endDate){
        filterData.endDate = this.endDate
      }

      this.filteredData = filterData

      this.getRevenue()

    },
    clear(){
      this.startDate = null
      this.endDate = null
      this.filteredData = {}
      this.getRevenue()

    },
    sendCall() {
      this.filterLoader = true
      this.makeRequest('post', 'v1/get-revenue-accounts', this.filteredData, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            this.accounts = data.accounts

            // let tempRefunded = []
            // if (data.exchangeRefundedRevenue) {
            //   data.exchangeRefundedRevenue.forEach(eachFeature => {
            //     tempRefunded[eachFeature.currency] = eachFeature
            //   })
            // }

            // let tempExchangeRevenue = []

            // if (data.exchangeRevenue) {
            //   data.exchangeRevenue.forEach((eachItem => {
            //     if (typeof (tempRefunded[eachItem.currency]) != 'undefined') {
            //       eachItem['refundedTotalAmount'] = tempRefunded[eachItem.currency]['totalAmount']
            //       eachItem['refundedTotalMarkupAmount'] = tempRefunded[eachItem.currency]['totalMarkupAmount']
            //     } else {
            //       eachItem['refundedTotalAmount'] = 0
            //       eachItem['refundedTotalMarkupAmount'] = 0
            //     }
            //     tempExchangeRevenue.push(eachItem)
            //   }))
            // }

            // this.exchangeRevenueTypes = tempExchangeRevenue


          }
          this.getRevenue()
        }
        this.filterLoader = false

      });

    },
    getRevenue() {
      this.filterLoader = true
      this.revenueLoader = true
      this.makeRequest('post', 'v1/get-revenue-accounts', {...this.filteredData,exchangeRevenue:1}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data

            let tempRefunded = []
            if (data.exchangeRefundedRevenue) {
              data.exchangeRefundedRevenue.forEach(eachFeature => {
                tempRefunded[eachFeature.currency] = eachFeature
              })
            }

            let tempExchangeRevenue = []

            if (data.exchangeRevenue) {
              data.exchangeRevenue.forEach((eachItem => {
                if (typeof (tempRefunded[eachItem.currency]) != 'undefined') {
                  eachItem['refundedTotalAmount'] = tempRefunded[eachItem.currency]['totalAmount']
                  eachItem['refundedTotalMarkupAmount'] = tempRefunded[eachItem.currency]['totalMarkupAmount']
                } else {
                  eachItem['refundedTotalAmount'] = 0
                  eachItem['refundedTotalMarkupAmount'] = 0
                }
                tempExchangeRevenue.push(eachItem)
              }))
            }

            this.exchangeRevenueTypes = tempExchangeRevenue


          }
        }
        this.filterLoader = false
        this.revenueLoader = false

      });

    },
  },

}
</script>


